interface BlogTag {
  id: number;
  label: string;
}

export const BLOG_TAGS: { [value: string]: BlogTag } = {
  LONGEVITY: {
    id: 1,
    label: "Ilgaamžiškumas",
  },
  GENETICS: {
    id: 2,
    label: "Genetika",
  },
  EPIGENETICS: {
    id: 3,
    label: "Epigenetika",
  },
  SUPPLEMENTS: {
    id: 4,
    label: "Maisto papildai",
  },
  LIFESTYLE: {
    id: 5,
    label: "Gyvensena",
  },
  BLOOD_TEST: {
    id: 6,
    label: "Kraujo tyrimai",
  },
  SPORTS: {
    id: 7,
    label: "Sportas",
  },
  PODCASTS: {
    id: 8,
    label: "Tinklalaidės",
  },
  GENOME: {
    id: 9,
    label: "Genomo sekoskaita",
  },
  SLEEP: {
    id: 10,
    label: "Miegas",
  },
};
